import serviceClient from '../../service-client/service-client';
import actions from '../actions';
import selectors from '../selectors';
import forceReloadView from '../../view/actions/force-reload-view';

export default () => async (dispatch, getState) => {
  const state = getState();
  const siteId = selectors.getSiteId(state);
  const apiClient = serviceClient.get();

  const { data: session } = await apiClient.getActiveSession(siteId);
  dispatch(actions.setSession({ session }));
  dispatch(forceReloadView());
};
